<form class="form-group" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="close-container">
    <mat-icon class="close-icon" (click)="closeDialog()"></mat-icon>
  </div>
  <div class="title title--lg dialog" mat-dialog-title>Edit Resident</div>
  <mat-dialog-content>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title">First Name</div>
        <input class="form-control" formControlName="{{firstNameControl}}" type="text" />
      </div>
      <div class="col-12 col-md-6">
        <div class="title">Last Name </div>
        <input class="form-control" formControlName="{{lastNameControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title">Email</div>
        <input class="form-control" formControlName="{{emailControl}}" type="text" />
      </div>
      <div class="col-12 col-md-6">
        <div class="title"> Additional Email </div>
        <input class="form-control" formControlName="{{noninstitutionalEmailControl}}" type="text" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title">NPI Number</div>
        <input class="form-control" formControlName="{{npiNumberControl}}" type="number" />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title"> Residency Post Graduate Year: {{pgy}} </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="title">Select whether Allopathic or Osteopathic Pathway:</div>
        <mat-select class="small--font" placeholder="Select a Pathway" formControlName="{{credentialCodeControl}}" disableRipple panelClass="mat-panel">
          <mat-option value="">Select a Pathway</mat-option>
          <mat-option *ngFor="let i of this.credentialList" [value]="i.credentialCode">{{i.credentialDescription}}</mat-option>
        </mat-select>
        <div class="required-text" *ngIf="invalidRequiredField(credentialCodeControl)">
          Pathway is required
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="title title--x">Start Date</div>
        <div class="dateContainer">
          <div class="date--form-control" (click)="startDatePicker.open()" [ngClass]="{'ng-invalid': this.startDateReasons?.length > 0}">
            <input class="form-control" [matDatepicker]="startDatePicker" formControlName="{{startDateControl}}" type="text" (dateChange)="validateDates()" />
          </div>
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker disabled="false" #startDatePicker></mat-datepicker>
        </div>
        <div class="required-text" *ngFor="let reason of this.startDateReasons">
          {{reason}}
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="title title--x">End Date</div>
        <div class="dateContainer">
          <div class="date--form-control" (click)="endDatePicker.open()" [ngClass]="{'ng-invalid': this.endDateReasons?.length > 0}">
            <input class="form-control" [matDatepicker]="endDatePicker" formControlName="{{endDateControl}}" type="text" (dateChange)="validateDates(); updatePGY();" />
          </div>
          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker disabled="false" #endDatePicker></mat-datepicker>
        </div>
        <div class="required-text" *ngFor="let reason of this.endDateReasons">
          {{reason}}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ul>
          <li *ngFor="let item of errors" class="required-text">{{item}}</li>
        </ul>
      </div>
    </div>


  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="btn--inline dialog-btn-container btn-align-right">
      <input type="button" class="btn btn--outline hide-on-mobile " (click)="closeDialog()" value="Cancel">
      <button class="btn btn--solid btn--red" type="submit" [disabled]="!isFormValid()">Save</button>
    </div>
  </div>
</form>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
